import React from 'react';
import clsx from 'clsx';
import { HeroIcons } from '@/components/design-system/atoms/icon';

interface NavigationButtonsProps {
  onScrollClick: (direction: 'left' | 'right') => void;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({ onScrollClick }) => {
  return (
    <button
      className={clsx(
        'hidden sm:flex flex-shrink-0 items-center justify-center',
        'rounded-full border border-border-primaryLight',
        'bg-bg-primaryLight',
        'sm:h-8 sm:w-8',
        'transition-all',
        'cursor-pointer hover:bg-bg-primaryHeavy hover:border-border-primaryMedium'
      )}
      aria-label="Scroll left"
      onClick={() => onScrollClick('left')}
      type="button"
    >
      <HeroIcons name="arrow-left" size={20} strokeColor="#495057" strokeWidth={3} />
    </button>
  );
};

const MobileNavigationButtons: React.FC<NavigationButtonsProps> = ({ onScrollClick }) => {
  return (
    <div className="flex items-center justify-center gap-4 sm:hidden">
      <button
        className={clsx(
          'flex items-center justify-center',
          'rounded-full border border-border-primaryLight',
          'bg-bg-primaryLight',
          'h-6 w-6',
          'transition-all',
          'cursor-pointer hover:bg-bg-primaryHeavy hover:border-border-primaryMedium'
        )}
        aria-label="Scroll left"
        onClick={() => onScrollClick('left')}
        type="button"
      >
        <HeroIcons name="arrow-left" size={18} strokeColor="#495057" strokeWidth={3} />
      </button>
      <button
        className={clsx(
          'flex items-center justify-center',
          'rounded-full border border-border-primaryLight',
          'bg-bg-primaryLight',
          'h-6 w-6',
          'transition-all',
          'cursor-pointer hover:bg-bg-primaryHeavy hover:border-border-primaryMedium'
        )}
        aria-label="Scroll right"
        onClick={() => onScrollClick('right')}
        type="button"
      >
        <HeroIcons name="arrow-right" size={18} strokeColor="#495057" strokeWidth={3} />
      </button>
    </div>
  );
};

const RightNavigationButton: React.FC<NavigationButtonsProps> = ({ onScrollClick }) => {
  return (
    <button
      className={clsx(
        'hidden sm:flex flex-shrink-0 items-center justify-center',
        'rounded-full border border-border-primaryLight',
        'bg-bg-primaryLight',
        'sm:h-8 sm:w-8',
        'transition-all',
        'cursor-pointer hover:bg-bg-primaryHeavy hover:border-border-primaryMedium'
      )}
      aria-label="Scroll right"
      onClick={() => onScrollClick('right')}
      type="button"
    >
      <HeroIcons name="arrow-right" size={20} strokeColor="#495057" strokeWidth={3} />
    </button>
  );
};

export { NavigationButtons, MobileNavigationButtons, RightNavigationButton };
